import { IonLabel } from '@ionic/react';
import { useTranslation } from 'react-i18next';
import ToggleInput from '../ToggleInput/ToggleInput';
import styles from './TermsConditionsWithdrawals.module.css';

type Props = {
  termsHandler: (type: string) => void;
  termsError?: boolean;
};

const TermsConditionsWithdrawals: React.FC<Props> = ({ termsHandler, termsError }) => {
  const { t } = useTranslation();

  return (
    <div>
      <ToggleInput
        labelText={t('wallet.withdrawals.terms.incorrect_address')}
        name="termsIncorrectAddress"
        toggleHandler={(event, name) => termsHandler(name)}
      />

      {termsError && (
        <IonLabel class="ion-text-wrap">
          <p className={styles.termsError}>{t('wallet.withdrawals.terms.error')}</p>
        </IonLabel>
      )}
    </div>
  );
};
export default TermsConditionsWithdrawals;
